import { render, staticRenderFns } from "./SubcontractorSettings.vue?vue&type=template&id=05557fb8&scoped=true"
import script from "./SubcontractorSettings.vue?vue&type=script&lang=js"
export * from "./SubcontractorSettings.vue?vue&type=script&lang=js"
import style0 from "./SubcontractorSettings.vue?vue&type=style&index=0&id=05557fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05557fb8",
  null
  
)

export default component.exports